import { CategoryAttributePlaceholder } from "../CategoryPage/CategoryAttributePlaceholder";

export const AttributePlaceholder = () => {
  return (
    <CategoryAttributePlaceholder
      id="product-attribute-placeholder"
      title="Product Attributes"
    >
      Product Attributes are flexible labels assigned to products, allowing
      users to search, filter, and export data with greater precision. Multiple
      attributes can be associated with a single product, enabling users to
      discover new or niche technologies, like &quot;Generative AI,&quot; more
      easily. Attributes provide a scalable way to categorize products in
      emerging fields, improving your ability to find relevant data quickly.
    </CategoryAttributePlaceholder>
  );
};
